<div class="customer-details-info">
  <div class="heading">
    <div>
      <span>{{ 'label.Customer' | translate }}</span>
    </div>
    <div>
      <a
        *ngIf="customer?.statusId == customerStatusEnum.Active"
        [routerLink]="
          customer ? ['/customers/edit/', customer?.customerId, 'details'] : []
        "
        >{{ 'label.Edit' | translate }}</a
      >
    </div>
  </div>
  <div class="content">
    <div>
      <div>
        <div>{{ 'label.CompanyName' | translate }}:</div>
        <div>{{ customer?.name }}</div>
      </div>
      <div>
        <div>{{ 'label.CompanyOtherName' | translate }}:</div>
        <div>{{ customer?.name2 }}</div>
      </div>
      <div>
        <div>{{ 'label.Industry' | translate }}:</div>
        <span *ngFor="let industry of customer?.industries; let last = last">
          {{ last ? industry.name : industry.name + ', ' }}
        </span>
        <span *ngIf="!customer?.industries?.length">
          {{ 'label.NotSelected' | translate }}
        </span>
      </div>
      <div>
        <div>{{ 'label.NumberOfEmployees' | translate }}:</div>
        <div>{{ customer?.numberOfEmployees }}</div>
      </div>
      <div>
        <div>{{ 'label.City' | translate }}:</div>
        <div>{{ customer?.locality?.name }}</div>
      </div>
      <div>
        <div>{{ 'label.CompanyWebsite' | translate }}:</div>
        <div>{{ customer?.website }}</div>
      </div>
      <div>
        <div>{{ 'label.PublicEmail' | translate }}:</div>
        <div>{{ customer?.publicEmail }}</div>
      </div>
      <div>
        <div>{{ 'label.CompanyDescription' | translate }}:</div>
        <div
          [innerHTML]="
            customer?.description != null
              ? customer.description + '&nbsp;'
              : '&nbsp;'
          "
        ></div>
      </div>
    </div>
    <div class="logo"><img src="{{ customer?.logoHref }}" /></div>
  </div>
</div>
